import logo from './logo.svg';
import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CookieConsent from "react-cookie-consent";

//import Indexs from './Indexs.js';
//import Auth2 from './Auth2.js';
import { ConvexProvider } from "convex/react";
import { client } from "./convexClient";
import PricingPage from './PricingPageaitravel.js';
import ProtectedRoute from './ProtectedRoute';
import Legal from './Legal.js';
import Indexsaitravel from './Indexsaitravel.js'
import Auth2aitravel from './Auth2aitravel.js';
import MFASetupaitavel from './MFASETUPaitravel.js';
import MFAVerifyaitravels from './MFAVerifyaitravels.js';
import TravalDashboard from './TravelDashboardaitravel.js';
import Privacy from "./Privacy";
import Terms from "./Terms";

//import 
function App() {

  return (
    <div>
      <ConvexProvider client={client}>
    <Router>
        <Routes>
        <Route path="/" element={<Indexsaitravel />} />
        <Route path="/auth" element={<Auth2aitravel />} />
        <Route path="/mfa-setup" element={<MFASetupaitavel />} />
        <Route path="/mfa-verify" element={<MFAVerifyaitravels />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/traveldashboard" element={
            <ProtectedRoute>
              <TravalDashboard />
            </ProtectedRoute>
          } /> 
        <Route path="/pricingpage" element={<PricingPage />} />      

        </Routes>
    </Router>
    <CookieConsent
          location="bottom"
          buttonText="Accept"
          declineButtonText="Decline"
          enableDeclineButton
          cookieName="travel_cookie_consent"
          style={{ background: "#111827" }}
          buttonStyle={{ background: "#6366f1", color: "#fff", fontSize: "14px" }}
          declineButtonStyle={{ background: "#374151", color: "#fff", fontSize: "14px" }}
          expires={150}
        >
          We use cookies to improve your experience, analyze traffic, and personalize content.
        </CookieConsent>
    </ConvexProvider>
  </div>
  );
}

export default App;
